import { Component, Input, Output } from '@angular/core';
import { StateOfCarService } from '@app/shared/services/state-of-car.service';
import { PhotoService } from '@app/shared/services/photo.service';
import { EventEmitter } from '@angular/core';
declare var UIkit: any;

@Component({
    selector: 'app-add-manager-state-of-car',
    templateUrl: './add-manager-state-of-car.component.html',
    styleUrls: ['./add-manager-state-of-car.component.scss']
})
export class AddManagerStateOfCarComponent {

    public stateOfCar: any = {
        photo: null,
        id_vehicle: 0,
        part: 1,
        location: '',
        description: '',
        supported: '',
        provider: ''
    };
    public photos: any = {
        front: null,
        back: null,
        left: null,
        right: null
    }
    public validated: boolean = false;
    public loading: boolean = false;

    @Input('id') id: number;
    @Output() changed = new EventEmitter();

    constructor(
        private stateOfCarService: StateOfCarService,
        private photoService: PhotoService
    ) { }

    ngOnChanges() {
        if (this.id !== 0) {
            this.stateOfCar.id_vehicle = this.id;
        }
    }

    resetVariables() {
        this.stateOfCar = {
            photo: null,
            id_vehicle: 0,
            part: 1,
            location: '',
            description: '',
            supported: '',
            provider: ''
        };
        this.validated = false;
        this.photos = {
            front: null,
            back: null,
            left: null,
            right: null
        }
    }

    modifyPhoto(part) {
        this.photoService.askFile().then((photo) => {
            switch (part) {
                case 1:
                    this.photos.front = photo;
                    break;
                case 2:
                    this.photos.back = photo;
                    break;
                case 3:
                    this.photos.left = photo;
                    break;
                case 4:
                    this.photos.right = photo;
                    break;
            }
            setTimeout(() => { this.validator(); });
        });
    }

    validator() {
        let result: boolean = true;

        this.validated = false;
        if (this.stateOfCar.location.length === 0 || this.stateOfCar.description.length === 0
            || this.photos.front === null || this.stateOfCar.id_vehicle === 0 || this.photos.back === null
            || this.photos.left === null || this.photos.right === null) {
            result = false;
        }
        this.validated = result;
    }

    submit() {
        let promises : Array<any> = [];

        this.loading = true;
        for (let i = 1; i <= 4; i++) {
            switch (i) {
                case 1:
                    this.stateOfCar.photo = this.photos.front;
                    this.stateOfCar.part = 1;
                    break;
                case 2:
                    this.stateOfCar.photo = this.photos.back;
                    this.stateOfCar.part = 2;
                    break;
                case 3:
                    this.stateOfCar.photo = this.photos.left;
                    this.stateOfCar.part = 3;
                    break;
                case 4:
                    this.stateOfCar.photo = this.photos.right;
                    this.stateOfCar.part = 4;
                    break;
            }
            promises.push(this.stateOfCarService.addManagerStateOfCar(this.stateOfCar));
        }
        Promise.all(promises).then(() => {
            this.changed.emit(null);
            this.loading = false;
            this.resetVariables();
            UIkit.modal('#add-manager-state-of-car').hide();
        });
    }

}
